export default __webpack_public_path__ + "static/media/close-icon-black.31acd95e.svg";